module.exports = __webpack_public_path__ + "je.55d15529.svg";